import { render, staticRenderFns } from "./AccountSettingSlot.vue?vue&type=template&id=5489f5ea&"
import script from "./AccountSettingSlot.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports